import { createContext, useContext, useEffect, useState } from "react";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [permissions, setPermissions] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    try {
      const storedUser = localStorage.getItem("Data");
      const storedPermissions = localStorage.getItem("permissions");
      const storedToken = localStorage.getItem("ntk");

      if (storedUser && storedToken) {
        const parsedUser = JSON.parse(storedUser);
        const parsedPermissions = storedPermissions
          ? JSON.parse(storedPermissions)
          : parsedUser.permissions || [];

        setUser(parsedUser);
        setPermissions(Array.isArray(parsedPermissions) ? parsedPermissions : []);
      }
    } catch (error) {
      console.error("Failed to restore auth state:", error);
      localStorage.removeItem("Data");
      localStorage.removeItem("ntk");
      localStorage.removeItem("userId");
      localStorage.removeItem("permissions");
    } finally {
      setLoading(false);
    }
  }, []);

  const login = (userData) => {
    if (!userData?.token) {
      throw new Error("Cannot create an authenticated session without a token.");
    }

    const nextPermissions = Array.isArray(userData.permissions)
      ? userData.permissions
      : [];

    setUser(userData);
    setPermissions(nextPermissions);
    localStorage.setItem("Data", JSON.stringify(userData));
    localStorage.setItem("ntk", userData.token);
    localStorage.setItem("userId", userData.id || "");
    localStorage.setItem("permissions", JSON.stringify(nextPermissions));
  };

  const logout = () => {
    setUser(null);
    setPermissions([]);
    localStorage.removeItem("Data");
    localStorage.removeItem("ntk");
    localStorage.removeItem("userId");
    localStorage.removeItem("permissions");
    sessionStorage.removeItem("pendingAdmin2FA");
  };

  return (
    <AuthContext.Provider
      value={{
        user,
        permissions,
        loading,
        isAuthenticated: Boolean(user),
        login,
        logout,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
